/**
 * Full-colour Google and Microsoft marks for the white OAuth buttons. Brand marks are the
 * one place fixed colours are allowed (design-of-record ui_kits/login, data-brand-mark).
 */

interface ProviderIconProps {
  size?: number
}

export function GoogleIcon({ size = 18 }: ProviderIconProps) {
  return (
    <svg data-brand-mark width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  )
}

export function MicrosoftIcon({ size = 17 }: ProviderIconProps) {
  return (
    <svg data-brand-mark width={size} height={size} viewBox="0 0 23 23" aria-hidden="true" focusable="false">
      <path d="M11.007 0H0v11.007h11.007z" fill="#f25022" />
      <path d="M23 0H11.993v11.007H23z" fill="#00a4ef" />
      <path d="M11.007 12H0V23h11.007z" fill="#7fba00" />
      <path d="M23 12H11.993V23H23z" fill="#ffb900" />
    </svg>
  )
}
